/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_SubtitleInputs */

const en_landing_showcase_subtitle = /** @type {(inputs: Landing_Showcase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posters, labels, signs and product shots. Lettering that holds, at native 2K.`)
};

const zh_landing_showcase_subtitle = /** @type {(inputs: Landing_Showcase_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海报、标签、招牌与产品图。文字稳定清晰，原生 2K。`)
};

/**
* | output |
* | --- |
* | "Posters, labels, signs and product shots. Lettering that holds, at native 2K." |
*
* @param {Landing_Showcase_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_subtitle = /** @type {((inputs?: Landing_Showcase_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_subtitle(inputs)
	return zh_landing_showcase_subtitle(inputs)
});
export { landing_showcase_subtitle as "landing.showcase.subtitle" }